import { createContext } from 'react';

const RequestContext = createContext({});

export default RequestContext;
